import React, { useState } from 'react';
import { useStore } from '@cobuildlab/react-simple-state';
import { createPairDialogStore } from '../pair-stores';
import { MuiDialog } from '../../../shared/components/dialog/MuiDialog';
import { createPairDialogStoreAction } from '../pair-actions';
import { StrategiesDocument, useCreateStrategyMutation } from '../../../shared/types/generated';
import { MuiInput } from '../../../shared/components/input/MuiInput';
import { Grid } from '@mui/material';

type CreatePairDialogProps = {
  onSuccess?: () => void;
}

const DATA = {
  symbol: '',
  time: [],
};

export const CreatePairDialog: React.FC<CreatePairDialogProps> = (
  {
    onSuccess,
  }) => {
  const { open } = useStore(createPairDialogStore);
  const [data, setData] = useState(DATA);
  const handleClose = (): void => {
    createPairDialogStoreAction({ open: false });
    setData(DATA);
  };

  const [create, { loading }] = useCreateStrategyMutation({
    awaitRefetchQueries: true,
    refetchQueries: [StrategiesDocument],
    onCompleted: () => {
      handleClose();
      if (onSuccess) onSuccess();
    },
  });

  return <MuiDialog
    open={Boolean(open)}
    handleClose={() => handleClose()}
    loading={loading}
    title='Add Pair'
    maxWidth='sm'
    handleSuccess={() => {
      create({
        variables: {
          data,
        },
      });
    }}
    fullWidth
    renderActions
  >
    <Grid container pt={2}>
      <Grid item xs={12}>
        <MuiInput
          variant='outlined'
          onChangeValue={(field, value) => setData({
            ...data,
            [field]: value,
          })}
          name='symbol'
          value={data.symbol}
          label='Pair' />
      </Grid>
    </Grid>
  </MuiDialog>;
};